import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import TableInstalacionesComponent from './Asociados/TableInstalacionesComponent';
import estilos from './Asociados/Tabs/TabsInspeccionarComponent.module.css'
import { useSelector } from 'react-redux';
import SolicitudesAsignadasComponent from './SolicitudesAsignadas/SolicitudesAsignadasComponent';
import { Download } from '@mui/icons-material';

import { hacerBackup } from '../../redux/DucksUnidadInspeccion/ModoOfflineDuck';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../redux/AppDucks';
import { host } from '../../configuraciones';

function PanelAsociados(props) {
    const clientes = useSelector(store => store.ModuloConsulta.clientes);
    const instalaciones = useSelector(store => store.Asociado.instalaciones);
    const relaciones = useSelector(store => store.ModuloConsulta.relacionesCliente)
    const todo = useSelector(store => store.ModuloConsulta.detalleCliente)


    const dispatch = useDispatch()

    React.useEffect(() => {
        return () => {
            //dispatch(ObtenerClientes())     //clientes       
            //dispatch(getInstalacionesByCliente(1))   //instalaciones
            //dispatch(obtenerTodasLasRelacionesClientes(1)) //relaciones
            //dispatch(obtenerClienteConDetalle(1)) //todo
        };
    }, []);

    const actualizarBDLocal = async () => {
        if (await hayConexionAInternet()) {
            console.log("hay")
        } else {
            // En caso de que no haya conexión a Internet
            console.log("nohay")
        }
        handleCloseConfirmar()
        dispatch(actualizarLoadingApp_true())
        dispatch(hacerBackup()).then((res) => {
            dispatch(actualizarLoadingApp_false())
            location.reload()
        })
    }

    async function hayConexionAInternet() {
        // Aquí deberías implementar la lógica para verificar la conexión a Internet.
        // Puedes hacer una solicitud a un servidor o utilizar una librería como Axios.
        // Asegúrate de manejar las promesas o utilizar el método necesario para la detección de conexión.
        try {
            // Realiza una solicitud a una URL en línea
            await fetch('http://52.22.169.24:7778');
            return true;
        } catch (error) {
            return false;
        }
    }

    const styleBox = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const [openConfirmar, setOpenConfirmar] = React.useState(false);

    const handleOpenConfirmar = () => {
        setOpenConfirmar(true)
    };
    const handleCloseConfirmar = () => setOpenConfirmar(false);

    const modalConfirmar = () => {
        return (
            <Modal
                open={openConfirmar}
                onClose={handleCloseConfirmar}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleBox}>
                    <div className='text-center'>
                        <h4>Se sincronizarán las solicitudes que se encuentran en la base de datos principal</h4><br />
                        <h6 style={{ color: 'red' }}><strong>Esto significa que las solicitudes no subidas al sistema se eliminarán y volverán a su estado inicial</strong></h6><br />
                        <h6 style={{ color: 'red' }}><strong>¿Esta seguro de realizar esta acción?</strong></h6><br />
                        <button className='btn btn-danger' onClick={actualizarBDLocal}> Confirmar</button>
                    </div>
                </Box>
            </Modal>
        )
    }

    return (
        <Fragment>
            <div className='container'>
                <SolicitudesAsignadasComponent></SolicitudesAsignadasComponent>
                {/* <div style={{ position: 'fixed', bottom: '20px', right: '20px' }}>
                    <button className='btn btn-warning' onClick={handleOpenConfirmar}><Download /> Actualizar Solicitudes</button>
                </div> */}
                {/* <Fragment>
                    <div className='row'>
                        <div className='col-xs-12 '>
                            <p className='mt-1' style={{ fontSize: '15px' }}>Panel de Clientes:</p>
                        </div>
                    </div>
                    <TableInstalacionesComponent></TableInstalacionesComponent>
                </Fragment> */}

            </div>

            {modalConfirmar()}
        </Fragment>
    );
};


export default withRouter(PanelAsociados)
